var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47492",
    "data-name": "Group 47492",
    transform: "translate(-265 -302.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3540",
    "data-name": "Ellipse 3540",
    transform: "translate(265 302.879)",
    fill: "#fff",
    stroke: "#ebebeb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47490",
    "data-name": "Group 47490",
    transform: "translate(404.9 -479.995) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y2: 12,
    transform: "translate(469.5 646.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y2: 12,
    transform: "translate(475.5 652.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.6e4c2bf22d08060cc090c4de2a7c97bf.svg";
export { ForwardRef as ReactComponent };